<template>
    <div>
        <b-modal v-model="openModal" centered size="md" title="Envio de arquivo Trafx" @ok="uploadFile()" no-close-on-backdrop no-close-on-esc hide-header-close>
            <b-container fluid>
                <b-row align-v="center">
                    <b-col cols="12">
                        <b-form-group label="Atrativos">
                            <b-form-select v-model="prod_uuid" :disabled="poisList.length == 1" class="mb-3">
                                <template #first>
                                    <b-form-select-option value="" disabled>Selecione o Atrativo</b-form-select-option>
                                </template>

                                <b-form-select-option v-for="(atrativo, idx) in poisList" :value="atrativo" :key="idx">
                                    {{ atrativo.product_name }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Arquivo" >
                            <b-form-file v-model="trafxFile" id="fileTrafxInput" placeholder="Selecione um arquivo Trafx..." accept=".txt" browse-text="Escolher"></b-form-file>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>

            <template #modal-footer>
                <b-row align-h="end">
                    <b-col cols="4">
                        <b-button @click="closeModal" variant="secondary" size="sm" class="float-right">Cancelar</b-button>
                    </b-col>

                    <b-col cols="4">
                        <b-button @click="retrieveFileContent" :disabled="prod_uuid.length == 0 || trafxFile == null" variant="primary" size="sm" class="float-right">Enviar</b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import swal from "sweetalert2"

export default {
    component: 'TrafxModalUpload',

    props:{
        openModal:{
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            trafxFile: null, prod_uuid: ""
        }
    },

    computed: {
        ...mapGetters('auth', {
            place: 'getPlace',
        }),

        ...mapGetters('product', {
            poisList: 'getPois',
        }),
    },

    watch: {
        poisList(newValue, oldValue){
            if(newValue.length == 1){
                this.prod_uuid = newValue[0]
            }
        },
    },

    methods: {
        ...mapActions('product', [
          'fetchPOIs',
        ]),

        ...mapActions('trafx', [
            'uploadTraxFile',
        ]),

        async retrieveFileContent(){
            const [file] = document.querySelector("input[type=file]").files;
            var fileReader = new FileReader()

            fileReader.addEventListener("load", () => {
                this.uploadTraxFile({ fileContent: fileReader.result, atrativo: this.prod_uuid })
                    .then(() => {
                        this.closeModal();
                        this.resetForm();
                        this.$emit("successOnUpload")
                        swal.fire({
                            title: "Sucesso!",
                            text: "Entradas TrafX enviadas com sucesso!",
                            type: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        })
                    })
                    .catch((err) => {
                        swal.fire({
                            title: "Falha ao enviar arquivo!",
                            text: err || "Não foi possível ler o arquivo.",
                            type: "warning",
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary"
                        })
                    })
            },false);

            if(file){
                fileReader.readAsText(file);
            }
        },

        resetForm(){ this.trafxFile = null; },

        closeModal(){ this.$emit("closeModal"); this.resetForm() }
    },

    mounted() {
      const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
      this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: "" })
    },

}

</script>
